import {invert} from 'lodash';

import {PublicQuestionModelV1} from 'resources/GeneratedModels/PublicQuestion/PublicQuestionModel.v1';
import constants from 'client/constants';

const difficultiesMap = invert(constants.QUESTION_IMPORT.DIFFICULTIES);

PublicQuestionModelV1.extend({
  getDifficultyLabel() {
    return difficultiesMap[this.getDifficulty()];
  }
});

export {PublicQuestionModelV1};
